<template>
  <div class="page">
    <div class="prview-content">
      <div class="title">{{ notify.title }}</div>
      <div class="author">{{ notify.createTime }}</div>
      <div class="content">
        {{ notify.content }}
      </div>
      <div class="detail" v-html="notify.remark"></div>
    </div>
  </div>
</template>

<style scoped="scoped">
.title {
}

.content {
  text-indent: 20px;
  padding: 5px 0;
  font-size: 14px;
}
</style>
<script>
import {
  getDetail,
  markRead
} from '@/api/notify.js'
import nativeApi from "@/utils/native-bridge";

export default {
  name: 'Notify',
  components: {},
  data() {
    return {
      notify: {}
    }
  },
  methods: {},
  created() {
    const id = this.$route.query.id;
    getDetail({
      id
    }).then((rep) => {
      this.notify = rep.data;
      this.$nextTick(() => {
        document.querySelectorAll('a').forEach(link => {
          link.addEventListener('click', function (event) {
            event.preventDefault();
            let href = link.getAttribute('href');
            if (href.indexOf('ca.weirenpaiqian.com') > -1) {
              nativeApi.openWebBrowser(href);
            } else {
              window.open(href, '_blank')
            }
          })
        })
      })
      markRead({
        id
      }).then(() => {
      });
    })
  }
}
</script>
